import { render } from "./Discography.vue?vue&type=template&id=df5f90e0"
import script from "./Discography.vue?vue&type=script&lang=js"
export * from "./Discography.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__